import api from './axios';

export const fetchSalons = (search) =>
  api.get('/client/salons', { params: { search } }).then((r) => r.data);

export const fetchSalonBranches = (tenantId) =>
  api.get(`/client/salons/${tenantId}/branches`).then((r) => r.data);

export const fetchSalonServices = (tenantId, branchId) =>
  api
    .get(`/client/salons/${tenantId}/services`, { params: { branchId } })
    .then((r) => r.data);
